import React from 'react';
import '../styles/Logos.css';

// `height` overrides the default 26px cell height for logos whose file is a
// tightly-cropped wordmark strip rather than a padded square tile; at the
// default height a strip blows up into a banner (bofa.png is 128×12).
const BANKS = [
  { name: 'Goldman Sachs', file: 'goldman-sachs.png' },
  { name: 'JP Morgan', file: 'jpmorgan.png' },
  { name: 'Morgan Stanley', file: 'morgan-stanley.png' },
  { name: 'Bank of America', file: 'bofa.png', height: 11 },
  { name: 'Citi', file: 'citi.png' },
  { name: 'Barclays', file: 'barclays.png' },
  { name: 'UBS', file: 'ubs.png' },
  { name: 'HSBC', file: 'hsbc.png' },
  { name: 'Nomura', file: 'nomura.png' },
  { name: 'Jefferies', file: 'jefferies.png' },
  { name: 'Lazard', file: 'lazard.png' },
  { name: 'Moelis', file: 'moelis.png' }
];

const FUNDS = [
  { name: 'Jane Street', file: 'jane-street.png' },
  { name: 'IMC', file: 'imc.png' },
  { name: 'DRW', file: 'drw.png' },
  { name: 'Citadel', file: 'citadel.png' },
  { name: 'Garda Capital', file: 'garda.png' },
  { name: 'Millennium', file: 'millennium.png' },
  { name: 'Optiver', file: 'optiver.png' }
];

interface LogoRowProps {
  label: string;
  logos: { name: string; file: string; height?: number }[];
  reverse?: boolean;
}

const LogoRow: React.FC<LogoRowProps> = ({ label, logos, reverse }) => (
  <div className="logo-row" data-reveal>
    <p className="logo-row-label">{label}</p>
    <div className="logo-marquee">
      <div className={`logo-track ${reverse ? 'logo-track-reverse' : ''}`}>
        {logos.concat(logos).map((logo, index) => (
          <span key={index} className="logo-cell" aria-hidden={index >= logos.length}>
            <img
              src={`/logos/${logo.file}`}
              alt={index < logos.length ? logo.name : ''}
              loading="lazy"
              style={logo.height ? { height: logo.height } : undefined}
            />
          </span>
        ))}
      </div>
    </div>
  </div>
);

const LogoWall: React.FC = () => {
  return (
    <section className="section logos" aria-label="Firms where our candidates hold offers">
      <div className="container">
        <LogoRow label="Our candidates hold offers from" logos={BANKS} />
        <LogoRow label="And on the buy side" logos={FUNDS} reverse />
      </div>
    </section>
  );
};

export default LogoWall;
